var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('router-link',{staticStyle:{"text-decoration":"none !important"},attrs:{"to":{name: 'lessons.show', params: _vm.params }}},[_vm._t("default")],2):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }